<style></style>
<template>
    <div id="connections-page">
        <div class="row">
            <div class="col">
                <h3 class="program-information">CONSULTANT INFORMATION</h3>
                <p>
                    <b>{{consultant.first_name}} {{consultant.last_name}} | <a class="primaryDark" v-bind:href="'mailto:'+consultant.email">{{consultant.email}}</a></b>
                </p>

                <p>
                    <b>{{consultant.city}}, {{consultant.state.abbreviation}}, {{consultant.zip}}</b>
                </p>

                <p>
                    Organization Type: <b>{{consultant.organization_type.name}}</b>
                </p>

                <div class="row">
                    <div class="col-md-2">
                        <p>Connections:</p>
                    </div>
                    <div class="col-md-10">
                        <p>
                            <b>{{consultant.connections.length}} Programs Connected</b>
                            <br />
                            <b>{{childrenServed}} Children Served</b>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div id="consultant-programs-page">
                    <div id="connected-programs">
                        <div class="table-template">
                            <BFormGroup horizontal label="Filter" class="d-md-none not-generic-form">
                                <BInputGroup>
                                    <BFormSelect v-model="sortBy" :options="sortFields">
                                        <option slot="first" :value="null">-- Filter --</option>
                                    </BFormSelect>
                                    <BFormSelect :disabled="!sortBy" v-model="sortDesc" slot="append">
                                        <option :value="false">Asc</option>
                                        <option :value="true">Desc</option>
                                    </BFormSelect>
                                </BInputGroup>
                            </BFormGroup>

                            <div class="row rounded-top find-program">
                                <div class="arrow-find-program">
                                    <img src="~public@/images/orange_arrow_blue_border.png">
                                    <span class="table-title">&nbsp;Connected Programs</span>
                                </div>
                                <div class="border-search d-none d-md-block">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="filter" placeholder="Type to Search" />
                                        <div class="input-group-append">
                                            <i class="fa fa-search my-auto"></i>
                                        </div>
                                    </div>
                                </div>
                            </div> 

                            <BTable
                                hover
                                stacked="md" 
                                :fields="fields" 
                                :items="consultant.connections"
                                :filter="filter"
                                @filtered="onFiltered"
                                :sort-by.sync="sortBy" 
                                :sort-desc.sync="sortDesc"
                                :current-page="currentPage" 
                                :per-page="perPage"
                            >
                            <template v-slot:cell(mostRecentAssessment)="data">
                                <div v-if="data.item.mostRecentAssessment" class="row icon-name-date">
                                    <div class="col-3 connected-icon">
                                        <div v-bind:class="data.item.mostRecentAssessment.icon + ' icon-rounded-corners pull-left module-icons-sm bg-'+ data.item.mostRecentAssessment.color"></div>
                                    </div>
                                    <div class="col connected-name-date">
                                        <div class="connected-name">{{data.item.mostRecentAssessment.name}}</div>
                                        <div class="connected-date">{{data.item.mostRecentAssessment.date}}</div>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:cell(mostRecentActionPlan)="data">
                                <div v-if="data.item.mostRecentActionPlan" class="row icon-name-date">
                                    <div class="col-3 connected-icon">
                                        <div v-bind:class="data.item.mostRecentActionPlan.icon + ' icon-rounded-corners pull-left module-icons-sm bg-'+ data.item.mostRecentActionPlan.color"></div>
                                    </div>
                                    <div class="col connected-name-date">
                                        <div class="connected-name">{{data.item.mostRecentActionPlan.name}}</div>
                                        <div class="connected-date">{{data.item.mostRecentActionPlan.date}}</div>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:cell(created_at)="data">
                                {{formatDate(data.item.created_at)}}
                            </template>
                            </BTable>

                            <BRow class="pagination-row justify-content-center">
                                <BPagination :total-rows="consultant.connections.length" :per-page="perPage" v-model="currentPage" hide-goto-end-buttons style="margin-left: 0"/>
                            </BRow>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col">
                <p>
                    &nbsp;&nbsp;&nbsp;<a :href="$basePath+'/dashboard'" class="more-information"><i class="fas fa-caret-left"></i> Back To All Consultants</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        props: {
            consultant: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                filter: null,
                fields: [
                    {
                        key: 'name',
                        label: 'Program Name',
                        sortable: true
                    },
                    {
                        key: 'created_at',
                        label: 'Date Joined',
                        sortable: true
                    },
                    {
                        key: 'mostRecentAssessment',
                        label: 'Most Recent Self-Assessment',
                        sortable: false
                    },
                    {
                        key: 'mostRecentActionPlan',
                        label: 'Most Recent Action Plan',
                        sortable: false
                    }
                ],
                currentPage: 1,
                perPage: 5,
                sortBy: null,
                sortDesc: false,
                loading: true
                }
        },
        methods:{
          onFiltered (filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
          },
          formatDate(date){
              return moment(date).format('M/D/Y')
          }
        },
        computed: {
            sortFields: function () {
                if (this.fields) {
                    return this.fields
                        .filter(f => f.sortable)
                        .map(f => { return { text: f.label, value: f.key } })
                }
                return new Array();
            },
            childrenServed: function() {
                var children = 0
                for (var i = 0; i < this.consultant.connections.length; i++) {
                    children += this.consultant.connections[i].children
                } 
                return children
            },
            $basePath() {
              return window.basePath;
            }
        }
    }
</script>